import { useEffect, useState } from 'react';

export interface RunActionState {
  id: string;
  actionTitle: string;
}

const DEFAULT_ACTION_TITLE = 'LiFT Coach';

export function useRunActionState() {
  const [runActionState, setRunActionState] = useState<RunActionState>({
    id: '',
    actionTitle: DEFAULT_ACTION_TITLE,
  });

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const actionTitle = queryParams.get('action') || DEFAULT_ACTION_TITLE;
    const practiceId = queryParams.get('id');

    if (practiceId) {
      setRunActionState({
        id: practiceId,
        actionTitle,
      });
    }
  }, []);

  return {
    runActionState,
    setRunActionState,
  };
}
